<ng-container *ngIf="isGraphOnly">
  <mat-card class="flx-card wd-mx crd-ovrflw bottom-card-ht">
    <mat-card-header class="grp_hdr">
      <article [ngClass]="['header-padding']">
        <div fxLayout="column" fxLayoutAlign="start center">
          <h4 ngClass="selectlist-label" *ngIf="dateType.type == 'Month'">Last 24 Month's Data</h4>
          <h4 ngClass="selectlist-label" *ngIf="dateType.type == 'Day'">Last 1 Month's Data</h4>
          <h4 ngClass="selectlist-label" *ngIf="dateType.type === 'Year'">Last 5 Year's Data</h4>
        </div>
        <nav class="nv_rt rpd">
          <div fxLayout="row" fxLayoutGap="10px">
            <div fxLayout="column" fxLayoutAlign="end center">
              <div fxLayout="row">
                <ng-container>
                  <h4
                    ngClass="selectlist-label"
                    *ngIf="
                      usageAnalyticsSelectedValue !== 'totalPlayedSession' &&
                      usageAnalyticsSelectedValue !== 'averageDuration' &&
                      usageAnalyticsSelectedValue !== 'masteredPracticeSets' &&                      
                      usageAnalyticsSelectedValue !== 'incorrectSession' &&
                      usageAnalyticsSelectedValue === 'all'
                    "
                  >
                    Usage :
                  </h4>
                  <h4 ngClass="selectlist-label" *ngIf="usageAnalyticsSelectedValue === 'totalPlayedSession'">Total Practice Set Sessions :</h4>
                  <h4 ngClass="selectlist-label" *ngIf="usageAnalyticsSelectedValue === 'averageDuration'">Average Session Duration :</h4>
                  <h4 ngClass="selectlist-label" *ngIf="usageAnalyticsSelectedValue === 'masteredPracticeSets'">Mastered Practice Sets :</h4>
                  <h4 ngClass="selectlist-label" *ngIf="usageAnalyticsSelectedValue === 'incorrectSession'">Incorrect Sessions :</h4>
                </ng-container>

                <ng-container>
                  <mat-form-field class="mrgn drpdown-chart-options" appearance="outline">
                    <mat-select [(ngModel)]="usageAnalyticsSelectedValue" name="usageAnalytics" (selectionChange)="changeAnalytics($event.value)">
                      <mat-option class="drp-options" *ngFor="let ua of usageAnalytics" [value]="ua.value">
                        {{ ua.viewValue }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ng-container>
              </div>
            </div>
            <div fxLayout="column">
              <i class="fa fa-share-square-o" aria-hidden="true" style="font-size: 24px; margin-top: 10px; color: #707070; cursor: pointer" (click)="exportCsvData('usage')"></i>
            </div>
          </div>
        </nav>
      </article>
    </mat-card-header>
    <mat-card-content class="flx_tm">
      <mat-spinner *ngIf="!sessionPlayedChartDatasets" diameter="20" ngClass="loader"></mat-spinner>
      <app-highcharts #highchartsComponent [height]="'450px'" [marginTop]="'20px'" [sereiesType]="'column'" [totalLessionsSessions]="totalLessionsSessions" [updateChart]="updateChart">
      </app-highcharts>
    </mat-card-content>
  </mat-card>
</ng-container>
